import Image from "next/image";

interface GameImageProps {
  src: string | null;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  /**
   * Set to `true` when this image is wrapped in a fixed-size container with a
   * slightly different aspect ratio than Steam's capsule (231:87 ≈ 2.655). The
   * 100×37 layout (used by rank-list rows) renders at 2.703, which triggers
   * Next.js's "aspect ratio modified" dev warning. `fillContainer` swaps to
   * object-cover sizing so the IMG element matches the wrapper exactly — no
   * warning, no visible distortion. Don't set this when the wrapper has no
   * explicit size (e.g. nav recently-viewed) — it'll stretch the image.
   */
  fillContainer?: boolean;
}

const FILL_STYLE: React.CSSProperties = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};

export function GameImage({
  src,
  alt,
  width = 130,
  height = 49,
  className = "",
  fillContainer = false,
}: GameImageProps) {
  if (src) {
    return (
      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        className={className}
        style={fillContainer ? FILL_STYLE : undefined}
        loading="lazy"
      />
    );
  }

  return (
    <div className="w-full h-full bg-[#1b2838] flex items-center justify-center">
      <span className="text-[#8f98a0] text-xs">No Image</span>
    </div>
  );
}

